// クライアント情報管理
import commonClass from "./commonClass";

export default class clientInfoClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._templateSelector = '.js-clinfo_tmpl';
    this._containerSelector = '.js-clinfo_ctnr';
    this._parentSelector = '.js-clinfo_prt';
    this._addTrgSelector = '.js-clinfo_trg_add';
    // this._delTrgSelector = '.js-clinfo_trg_del';
    this._dateLabelSelector = '.js-clinfo_datelbl';
    this._dateInputSelector = '.js-clinfo_dateipt';

    this._tglDelLblSelector = '.js-clinfo_dellbl';
    this._tglDelSelector = '.js-clinfo_delipt';

    this.$_tmpl = null;

    this._cnt = 0; // アイテム数、_attrPrefix_dateと組み合わせて一意の文字列を生成
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    cls._getTemplate();
    cls._getItemNum();

    $(document).on('click', cls._addTrgSelector, function() {
      cls._add($(this));
    });

    // チェックボックスON/OFFでブロック全体をDisable（削除）にする
    APP.BlockDisable._setSelector(cls._tglDelSelector, cls._parentSelector);
  }

  _getItemNum() {
    var cls =  this;

    // 初期表示時のアイテム数取得
    cls._cnt = $(cls._parentSelector).length;
  }

  _getTemplate() {
    var cls = this;

    $(cls._templateSelector).find('.js-datepicker').datepicker('destroy');
    cls.$_tmpl = $(cls._templateSelector).clone();
    $(cls._templateSelector).remove();
  }

  // 追加処理
  _add($self) {
    var cls = this;
    var $tmpl = cls.$_tmpl.clone();

    cls._cnt++;
    $tmpl.find('.js-datepicker').attr('id', 'dp' + cls._getUniqueString());
    $tmpl.find('.js-datepicker').datepicker(APP.DatePicker._baseSetting).next('.ui-datepicker-trigger').addClass('c-btn_datepick');
    // 2020.12.14 保障数のコピー
    $tmpl.find('.AssuranceCount').val($('#AssuranceCount').val());
    $tmpl.appendTo(cls._containerSelector).fadeIn();

    return false;
  }
}